import React, { useState, useEffect } from 'react';
import { ArrowLeft, X, Clock, CheckCircle, Download } from 'lucide-react';
import './paymentStatusCard.css';
import { CrossButton } from 'components';
import { StorageServices } from 'utils';
import { getPaymentDetailsApi } from '_services';
import Loading from 'pages/Loading';

const PaymentStatusCard = ({
    isOpen,
    onClose,
    onShareReceipt,
    details,
    viewReceiptHandle,
    doneHandle
}) => {
    const [currentStatus, setCurrentStatus] = useState();
    const [paymentStatusDetails, setPaymentStatusDetails] = useState({});
    const [isLoadingDetails, setIsLoadingDetails] = useState(true)

    useEffect(() => {
        if (details?._id) {
            getPaymentDetailsHandle(details?._id);
        }
    }, [details?._id]);

    const getPaymentDetailsHandle = async (id) => {
        const payload = {
            company_id: StorageServices?.getCompanyId(),
            voucher_id: id
        };

        try {
            setIsLoadingDetails(true)
            const res = await getPaymentDetailsApi(payload);
            if (res?.responseCode === 200) {
                const voucherData = res?.data?.voucher;
                setPaymentStatusDetails(voucherData);
                // Set status based on eb_txn_status
                if (voucherData?.approval_status == 5) {
                    setCurrentStatus('successful');
                } else if (voucherData?.approval_status == 9) {
                    setCurrentStatus('failed');
                } else if ((voucherData?.approval_status == 8)) {
                    setCurrentStatus('initiated');
                } else if ((voucherData?.approval_status == 4)) {
                    setCurrentStatus('Reject');
                }
                setIsLoadingDetails(false)

            }
        } catch (error) {
            console.error('Error fetching payment details:', error);
            setCurrentStatus(4);
        } finally {
            setIsLoadingDetails(false)
        }
    };
    // Format date
    const formatDate = (dateString) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        return date.toLocaleDateString('en-IN', {
            day: '2-digit',
            month: 'short',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
    };

    // Get payment details from paymentStatusDetails
    const getPaymentDetails = () => {
        const details = paymentStatusDetails;

        return {
            userName: details?.vendor_bank_account?.account_name ||
                details?.vendor_detail?.name ||
                details?.to_account?.name ||
                'N/A',
            bankName: details?.vendor_bank_account?.bank_name || 'N/A',
            bankAccount: details?.vendor_bank_account?.account_number || 'N/A',
            ifsc: details?.vendor_bank_account?.ifsc_code || 'N/A',
            upiId: details?.vendor_bank_account?.upi_id || '',
            amount: details?.total_amount || 0,
            date: formatDate(details?.date || details?.createdAt),
            voucherNo: details?.voucher_no || '',
            transactionNo: details?.transaction_no || '',
            ebRequestNumber: details?.eb_request_number || '',
            ebTransactionRef: details?.eb_transaction_reference || '',
            vendorName: details?.vendor_detail?.name || '',
            panNo: details?.vendor_detail?.pan_no || '',
            vehicleNo: details?.tags?.vehicle?.vehicle_no || '',
            paymentMode: details?.payment_mode?.name || '',
            category: details?.categories?.[0]?.category?.name || '',
            description: details?.description || ''
        };
    };

    const paymentDetails = getPaymentDetails();

    const getStatusConfig = () => {
        
        switch (currentStatus) {
            case 'successful':
                return {
                    icon: <CheckCircle size={32} color="#fff" strokeWidth={2.5} />,
                    title: 'Payment Successful',
                    bgClass: 'status-success-bg',
                    iconClass: 'status-success-icon'
                };
            case 'failed':
                return {
                    icon: <X size={32} color="#fff" strokeWidth={3} />,
                    title: 'Payment Failed',
                    bgClass: 'status-failed-bg',
                    iconClass: 'status-failed-icon'
                };

            case 'Reject':
                return {
                    icon: <X size={32} color="#fff" strokeWidth={3} />,
                    title: 'Payment Reject',
                    bgClass: 'status-failed-bg',
                    iconClass: 'status-failed-icon'
                };
            case 'initiated':
            default:
                return {
                    icon: <Clock size={32} color="#fff" strokeWidth={2.5} />,
                    title: 'Payment Initiated',
                    bgClass: 'status-initiated-bg',
                    iconClass: 'status-initiated-icon'
                };
        }
    };

    const statusConfig = getStatusConfig();

    const getInitials = (name) => {
        if (!name) return '??';
        return name
            .split(' ')
            .map(word => word[0])
            .join('')
            .toUpperCase()
            .slice(0, 2);
    };

    return (
        <div>
            <div
                // className={`payment-status-offcanvas payment-status-offcanvas-end common_offCanvas ${isOpen ? "show" : ""}`}
                className={`offcanvas offcanvas-end common_offCanvas ${isOpen ? "show" : ""}`}


                tabIndex={-1}
                style={{
                    visibility: isOpen ? "visible" : "hidden",
                }}
            >
                {isOpen && (
                    <>
                        {/* Header */}
                        <div className="offcanvas-header payment-offcan-header">
                            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                <button
                                    className="payment-status-back-button"
                                    onClick={onClose}
                                >
                                    <ArrowLeft size={20} color="#000" />
                                </button>
                                <h5 className="offcanvas-title">Payment Status</h5>
                            </div>

                            <CrossButton type="button" className="_switchBtn  __animEffect_btn" style={{ marginLeft: 'auto' }} onClick={onClose}>
                                <svg className="cross" xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none" >
                                    <path
                                        d="M12.5321 0.477671C12.4422 0.387555 12.3353 0.316061 12.2177 0.267281C12.1001 0.2185 11.9741 0.193391 11.8468 0.193391C11.7195 0.193391 11.5934 0.2185 11.4758 0.267281C11.3582 0.316061 11.2514 0.387555 11.1615 0.477671L6.40798 5.22143L1.6545 0.46795C1.56451 0.377952 1.45766 0.306563 1.34008 0.257857C1.22249 0.20915 1.09646 0.184082 0.969185 0.184082C0.84191 0.184082 0.715881 0.20915 0.598294 0.257857C0.480707 0.306563 0.373865 0.377952 0.283868 0.46795C0.19387 0.557947 0.122481 0.664789 0.0737746 0.782376C0.0250685 0.899963 -9.48274e-10 1.02599 0 1.15327C9.48275e-10 1.28054 0.0250684 1.40657 0.0737746 1.52416C0.122481 1.64175 0.19387 1.74859 0.283868 1.83858L5.03735 6.59206L0.283868 11.3455C0.19387 11.4355 0.122481 11.5424 0.0737746 11.66C0.0250685 11.7776 0 11.9036 0 12.0309C0 12.1581 0.0250685 12.2842 0.0737746 12.4017C0.122481 12.5193 0.19387 12.6262 0.283868 12.7162C0.373865 12.8062 0.480707 12.8776 0.598294 12.9263C0.715881 12.975 0.84191 13 0.969185 13C1.09646 13 1.22249 12.975 1.34008 12.9263C1.45766 12.8776 1.56451 12.8062 1.6545 12.7162L6.40798 7.9627L11.1615 12.7162C11.2515 12.8062 11.3583 12.8776 11.4759 12.9263C11.5935 12.975 11.7195 13 11.8468 13C11.974 13 12.1001 12.975 12.2177 12.9263C12.3353 12.8776 12.4421 12.8062 12.5321 12.7162C12.6221 12.6262 12.6935 12.5193 12.7422 12.4017C12.7909 12.2842 12.816 12.1581 12.816 12.0309C12.816 11.9036 12.7909 11.7776 12.7422 11.66C12.6935 11.5424 12.6221 11.4355 12.5321 11.3455L7.77861 6.59206L12.5321 1.83858C12.9015 1.46919 12.9015 0.847062 12.5321 0.477671Z"
                                        fill="black"
                                    />
                                </svg>
                            </CrossButton>
                        </div>

                        {/* Body */}
                        {!isLoadingDetails && <div className="offcanvas-body payment-offcan-body">
                            <div className="payment-status-card-wrapper">
                                {/* Status Header */}
                                <div className={`payment-status-header ${statusConfig.bgClass}`}>
                                    <div className={`payment-status-icon ${statusConfig.iconClass}`}>
                                        {statusConfig.icon}
                                    </div>
                                    <h2 className="payment-status-title">{statusConfig.title}</h2>
                                    <p className="payment-status-date">{paymentDetails.date}</p>
                                </div>

                                {/* Payment Details Card */}
                                <div className="payment-details-card">
                                    {/* User Info Section */}
                                    <div className="user-info-section">
                                        <div className="user-avatar">
                                            {getInitials(paymentDetails.userName)}
                                        </div>
                                        <div className="user-details">
                                            <h3 className="user-name">{paymentDetails.userName}</h3>
                                            {paymentDetails.vendorName && paymentDetails.vendorName !== paymentDetails.userName && (
                                                <p className="bank-info">Vendor: {paymentDetails.vendorName}</p>
                                            )}
                                            <p className="bank-info">{paymentDetails.bankName}: {paymentDetails.bankAccount}</p>
                                            <p className="bank-info">IFSC: {paymentDetails.ifsc}</p>
                                            {paymentDetails.upiId && (
                                                <p className="bank-info">UPI: {paymentDetails.upiId}</p>
                                            )}
                                            <p className="payment-amount">Amount: ₹{paymentDetails.amount}</p>
                                        </div>
                                    </div>



                                    {/* Action Buttons */}
                                    <div className="action-buttons-status">
                                        <button
                                            className="action-btn-status view-details-btn"
                                            onClick={() => {
                                                viewReceiptHandle(paymentStatusDetails)
                                            }}
                                        >
                                            View Details
                                        </button>
                                        <div className='status-btn-line'></div>
                                        <button
                                            className="action-btn-status share-receipt-btn"
                                            onClick={onShareReceipt}
                                        >
                                            Share Receipt
                                        </button>
                                    </div>
                                </div>

                                {/* Advertisement Section */}
                                <div className="advertisement-section">
                                    <p className="ad-label">Advertisement</p>
                                </div>
                            </div>
                        </div>}
                        {isLoadingDetails && <div className="loaderBg" style={{ textAlign: "center" }}><Loading /></div>}
                        {/* Footer */}
                        {!isLoadingDetails && <div className="offcanvas-footer payment-offcan-footer">
                            <button className="payment-status-done-btn" onClick={() => {
                                doneHandle()
                            }}>
                                Done
                            </button>
                        </div>}
                    </>
                )}
            </div>

            {/* Backdrop */}
            {isOpen && <div className="payment-status-offcanvas-backdrop" onClick={onClose}></div>}
        </div>
    );
};

export default PaymentStatusCard;